<template>
  <b-modal
    id="xoa-vai-tro-thuoc-nguoi-dung"
    centered
    hide-footer
    size="md"
    header-class="border-bottom-none"
    footer-class="border-top-none"
    title="Bạn có chắc chắn xóa vai trò thuộc người dùng?"
  >
    <div class="d-flex justify-content-end">
      <base-button button="Xóa" class="btn btn-main" @click="xoaVaiTro()">
        ĐỒNG Ý
      </base-button>
      <base-button
        button="Hủy"
        class="btn btn-line ml-2"
        @click="hideModal()"
      >
      </base-button>
    </div>
  </b-modal>
</template>
<script>
import { ROUTE_NAME, BO_QUA_BUTTON_LABEL } from "@/constants/constants";

export default {
  name: "XoaVaiTroThuocNguoiDungModal",
  props: {},
  data() {
    return {
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      ROUTE_NAME: ROUTE_NAME,
      emailSelected: 1,
      modalTitle: "",
      internalForm: {},
    };
  },
  watch: {
    form: {
      handler() {
        this.internalForm = this.form;
      },
      immediate: true,
    },
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("xoa-vai-tro-thuoc-nguoi-dung");
    },
    xoaVaiTro() {
      this.$bvModal.hide("xoa-vai-tro-thuoc-nguoi-dung");
      this.$emit("xoaDanhSachVaiTroThuocNguoiDung");
    },
  },
};
</script>

<style lang="scss">
#xoa-vai-tro-thuoc-nguoi-dung .modal-header {
  background: white;
  h5 {
    color: black;
  }

  .close {
    display: none;
  }
}
</style>
